import { Action } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

import { CartGroup, CartGroupRaw, CartItem, CartNode, CartParams, CartSampling } from '../../model/cart.model';
import { OrderStatus } from '../../constants/order-status';
import { LimbusErrorResponse } from '../../model/limbus-error-response.model';
import { OrderInformation } from '../../model/order-information.model';


export const GET_CART = 'GET_CART';
export const RELOAD_CART = 'RELOAD_CART';
export const GET_CART_SUCCESS = 'RELOAD_CART_SUCCESS';
export const GET_CART_FAIL = 'GET_CART_FAIL';
export const ADD_CART_ITEM = 'ADD_CART_ITEM';
export const UPDATE_CART_ITEM = 'UPDATE_CART_ITEM';
export const DELETE_CART_ITEMS = 'DELETE_CART_ITEMS';
export const UPDATE_AUTOPOPULATED_CART_ITEM = 'UPDATE_AUTOPOPULATED_CART_ITEM';
export const UPDATE_CART = 'UPDATE_CART';
export const UPDATE_CART_FAIL = 'UPDATE_CART_FAIL';
export const PLACE_ORDER = 'PLACE_ORDER';
export const PLACE_ORDER_SUCCESS = 'PLACE_ORDER_SUCCESS';
export const PLACE_ORDER_FAILURE = 'PLACE_ORDER_FAILURE';
export const SET_SAMPLING_SUPPLIES_GRP_ID = 'SET_SAMPLING_SUPPLIES_GRP_ID';
export const SET_SAMPLING_SUPPLIES_SAMPLING = 'SET_SAMPLING_SUPPLIES_SAMPLING';
export const CREATE_CART = 'CREATE_CART';
export const SET_ORDER_STATUS = 'SET_ORDER_STATUS';
export const CLEAR_LIMBUS_ERROR_RESPONSE = 'CLEAR_LIMBUS_ERROR_RESPONSE';
export const SET_LIMBUS_ERROR_RESPONSE = 'SET_LIMBUS_ERROR_RESPONSE';
export const ADD_CART_PARAMS = 'ADD_CART_PARAMS';
export const RESET_CART_PARAMS = 'RESET_CART_PARAMS';
export const UPDATE_SAMPLING_NAME = 'UPDATE_SAMPLING_NAME';
export const SET_GROUP_ERRROR_MESSAGE = 'SET_GROUP_ERRROR_MESSAGE';
export const DELETE_CART_GROUP = 'DELETE_CART_GROUP';
export const SET_IS_ADDING_ANALYTICAL_TEST = 'SET_IS_ADDING_ANALYTICAL_TEST';
export const CREATE_PRODUCT_SAMPLING = 'CREATE PRODUCT SAMPLING';
export const LOAD_RECOMMENDED_SUPPLIES = '[Cart] Load Recommended Supplies]';
export const UPDATE_CONTACT_DETAILS = 'UPDATE_CONTACT_DETAILS';

export class GetCart implements Action {
    readonly type = GET_CART;

    constructor(public cartId: string) {}
}

export class ReloadCart implements Action {
    readonly type = RELOAD_CART;
    constructor() {}
}

export class GetCartSucces implements Action {
    readonly type = GET_CART_SUCCESS;
    constructor() {}
}

export class GetCartFail implements Action {
    readonly type = GET_CART_FAIL;
    constructor() {}
}

export class UpdateContactDetails implements Action {
    readonly type = UPDATE_CONTACT_DETAILS;

    constructor(public payload: any, public profileId: string, public silent = false) {
    }
}

export class AddCartItem implements Action {
    readonly type = ADD_CART_ITEM;

    constructor(public payload: CartItem, public sampling: { groupId: number; name: string } = null) {}
}

export class UpdateCartItem implements Action {
    readonly type = UPDATE_CART_ITEM;

    constructor(
        public payload: CartItem,
        public sampling: { groupId: number; name: string } = null) {}
}

export class DeleteCartItems implements Action {
    readonly type = DELETE_CART_ITEMS;

    constructor(
        public payload: CartItem[],
        public sampling: { groupId: number; name: string } = null) {}
}

export class UpdateAutoPopulatedCartItem implements Action {
    readonly type = UPDATE_AUTOPOPULATED_CART_ITEM;

    constructor(
        public payload: CartItem,
        public sampling: { groupId: number; name: string } = null) {}
}

export class UpdateCart implements Action {
    readonly type = UPDATE_CART;

    constructor(public payload: CartNode, public itemId?: number, public groupId?: number) {}
}
export class UpdateCartFail implements Action {
    readonly type = UPDATE_CART_FAIL;
    constructor(public error?: any, public cartId?: string, public groupId?: number, public itemId?: number) {}
}

export class PlaceOrder implements Action {
    readonly type = PLACE_ORDER;

    constructor(public order: OrderInformation, public samplingSupplyItemsToAdd: CartItem[] = []) {}
}

export class PlaceOrderSuccess implements Action {
    readonly type = PLACE_ORDER_SUCCESS;

    constructor(public payload: CartNode) {}
}

export class PlaceOrderFailure implements Action {
    readonly type = PLACE_ORDER_FAILURE;

    constructor(public payload: HttpErrorResponse) {}
}

export class SetSamplingSuppliesGroupId implements Action {
    readonly type = SET_SAMPLING_SUPPLIES_GRP_ID;

    constructor(public group: CartGroupRaw) {}
}

export class SetSamplingSuppliesSampling implements Action {
    readonly type = SET_SAMPLING_SUPPLIES_SAMPLING;

    constructor(public sampling: CartSampling) {}
}

export class CreateCart implements Action {
    readonly type = CREATE_CART;

    constructor(public cart) {}
}

export class SetOrderStatus implements Action {
    readonly type = SET_ORDER_STATUS;

    constructor(public value: OrderStatus) {}
}

export class SetLimbusErrorResponse implements Action {
    readonly type = SET_LIMBUS_ERROR_RESPONSE;

    constructor(public errors: LimbusErrorResponse) {}
}

export class ClearLimbusErrorResponse implements Action {
    readonly type = CLEAR_LIMBUS_ERROR_RESPONSE;

    constructor() {}
}

export class AddCartParams implements Action {
    readonly type = ADD_CART_PARAMS;

    constructor(public cartParams: CartParams) {}
}


export class ResetCartParams implements Action {
    readonly type = RESET_CART_PARAMS;

    constructor() {}
}

export class UpdateSampleName implements Action {
    readonly type = UPDATE_SAMPLING_NAME;

    constructor(public groupId: number, public groupNewName: string) {}
}

export class DeleteCartGroup implements Action {
    readonly type = DELETE_CART_GROUP;

    constructor(public groupId: number) {}
}

export class SetGroupErrorMessage implements Action {
    readonly type = SET_GROUP_ERRROR_MESSAGE;

    constructor(public errorResponse: HttpErrorResponse, public groupId: number, public userInputGroupName: string) {}
}

export class SetIsAddingAnalyticalTest implements Action {
    readonly type = SET_IS_ADDING_ANALYTICAL_TEST;

    constructor(public state: boolean) {}
}

export class CreateProductSampling implements Action {
    readonly type = CREATE_PRODUCT_SAMPLING;

    constructor() {}
}

export class LoadRecommendedSupplies implements Action {
    readonly type = LOAD_RECOMMENDED_SUPPLIES;

    constructor(public items: CartItem[]) {}
}

export type CartActions = GetCart
| ReloadCart
| GetCartSucces
| GetCartFail
| AddCartItem
| UpdateCartItem
| UpdateCart
| PlaceOrder
| PlaceOrderSuccess
| PlaceOrderFailure
| UpdateContactDetails
| SetSamplingSuppliesGroupId | SetSamplingSuppliesSampling
| CreateCart | SetOrderStatus
| ClearLimbusErrorResponse
| SetLimbusErrorResponse
| AddCartParams | ResetCartParams | UpdateSampleName | DeleteCartGroup | SetGroupErrorMessage
| SetIsAddingAnalyticalTest | UpdateCartFail
| CreateProductSampling
| LoadRecommendedSupplies;
